import { Text, Modal as ModalBase } from '@village/ui';
import styled from 'styled-components';
import { device } from 'utils/device';

const Modal = styled(ModalBase)`
    z-index: 30;
`;

const ModalWrapper = styled.div`
    position: relative;
    margin-top: 2.5rem;
    max-height: 90vh;
    overflow: auto;

    @media ${device.minTablet} {
        width: 40em;
    }
`;

const Content = styled(Text)`
    overflow: auto;
    padding: 0 1rem;
    color: ${({ theme }) => theme.vui.colors.text.default};

    & p {
        margin: 1rem 0;
    }

    & .disclaimer {
        background-color: #f4f4f4;
        border: 1px solid #ddd;
        padding: 15px;
        margin-top: 0;
        margin-bottom: 1.5rem;
        font-weight: bold;
    }

    & .section-header {
        text-decoration: underline;
        font-weight: bold;
        margin-top: 1.5rem;
    }

    & a {
        color: #06c;
    }

    & ul {
        padding-left: 30px;
    }
`;

const FooterSection = styled.footer`
    position: sticky;
    bottom: 0;
    padding: 1.5rem 0.5rem;
    width: 100%;
    background-color: white;
`;

const ModalHeaderSection = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1.5rem;
    height: 100%;
    overflow: hidden;
`;

export { Content, ModalHeaderSection, FooterSection, Modal, ModalWrapper };
